<template>
  <div>
    <span>Mostrar</span>
    <select
      class="form-control"
      @change="event => $emit('updatePerPage', Number(event.target.value))"
    >
      <option
        v-for="(n, index) in options"
        :value="n === 'Todos' ? 0 : n"
        :key="index"
        :selected="n == perPage"
      >
        {{ n }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    perPage: [Number],
    options: {
      type: Array,
      default() {
        return [10, 25, 50, 100, 'Todos']
      }
    }
  }
}
</script>
<style scoped>
div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
}

span {
  margin-right: 10px;
  align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/NoApiTable/VuetableLengthChange.vue